// JsFromRoutes CacheKey 0ba1404e7dfa0381f0383c61d70e3d14
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '(/:locale)/settings'),
  update: /* #__PURE__ */ definePathHelper('patch', '(/:locale)/settings'),
}
